import React, { FC } from "react";
import { Input, Tooltip } from "@xapp/components";
import compact from "styles/overrides/input-compact.scss";

export interface MasterDetailSearchProps {
    placeholder?: string;
    tooltip?: string;
    value: string;
    onChange(newVal: string): void;
}

const MasterDetailSearch: FC<MasterDetailSearchProps> = (props: MasterDetailSearchProps) => {
    const { placeholder, tooltip, ...rest } = props;

    const inputProps = {
        placeholder: placeholder || "search",
        className: compact.input,
        ...rest
    };

    return tooltip ? <Tooltip content={tooltip}><Input {...inputProps} /></Tooltip> : <Input {...inputProps} />;
};

export { MasterDetailSearch };
